"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var config_1 = __importDefault(require("config"));
var api_1 = __importStar(require("api"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var use_dialog_1 = require("hooks/use-dialog");
var AddButton_1 = __importDefault(require("components/common/buttons/AddButton"));
var EditProductOptionsGroup_1 = __importDefault(require("./EditProductOptionsGroup"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var SelectWithNewEntry_1 = __importDefault(require("components/common/inputs/SelectWithNewEntry"));
var Notification_1 = require("../../../Notification");
var Dialog_1 = require("../../../Dialog");
var help_icon_svg_1 = __importDefault(require("../../../../res/img/help-icon.svg"));
var SAVE_MESSAGE = 'Product has been saved';
var apiRoutes = config_1.default.apiRoutes;
var EditProductOptions = mobx_react_1.observer(function (_a) {
    var product = _a.product;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var _c = use_stores_1.useStores(), productOptionsStore = _c.productOptionsStore, productsStore = _c.productsStore, apiStore = _c.apiStore;
    var busyRoutes = apiStore.data.busyRoutes;
    var dialog = use_dialog_1.useDialog();
    var notification = use_notification_1.useNotification();
    react_1.useEffect(function () {
        if (productOptionsStore.data.length <= 0 &&
            !busyRoutes.includes(apiRoutes.PRODUCT_OPTIONS)) {
            api_1.default.getProductOptions()
                .then(function (response) { return productOptionsStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
    }, []);
    var toggleOpen = function () {
        setOpen(!open);
    };
    var getStoreOptions = function (optionId) {
        for (var _i = 0, _a = productOptionsStore.data; _i < _a.length; _i++) {
            var productOption = _a[_i];
            if (productOption.id === optionId)
                return productOption.productOptionItems;
        }
    };
    var getOptions = function () {
        return productOptionsStore.data.map(function (storeOption) {
            if (product.productOptions) {
                for (var _i = 0, _a = product.productOptions; _i < _a.length; _i++) {
                    var dataOption = _a[_i];
                    if (storeOption.id === dataOption.id) {
                        return __assign(__assign({}, storeOption), { live: false });
                    }
                }
            }
            return storeOption;
        });
    };
    var putOption = function (productOption) {
        api_1.default.putProductOption(product.id, productOption.id)
            .then(function (response) {
            productsStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: SAVE_MESSAGE
            });
        })
            .catch(api_1.catchHandler);
    };
    var submitOptionHandler = function (value) {
        api_1.default.createProductOption({ name: value })
            .then(function (response) {
            productOptionsStore.addDataItem(response.data);
            putOption(response.data);
        })
            .catch(api_1.catchHandler);
    };
    var removeOptionHandler = function (productOption) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Remove " + productOption.name + " Option Group?",
            description: 'Are you sure you want to remove this option group?'
        })
            .then(function () {
            api_1.default.removeProductOption(product.id, productOption.id)
                .then(function (response) {
                productsStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: SAVE_MESSAGE
                });
            })
                .catch(api_1.catchHandler);
        });
    };
    var putOptionItem = function (productOptionItem) {
        api_1.default.putProductOptionItem(product.id, productOptionItem.id)
            .then(function (response) {
            productsStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: SAVE_MESSAGE
            });
        })
            .catch(api_1.catchHandler);
    };
    var submitItemHandler = function (productOption, value) {
        var targetOption = {};
        for (var _i = 0, _a = productOptionsStore.data; _i < _a.length; _i++) {
            var storeOption = _a[_i];
            if (storeOption.id === productOption.id)
                targetOption = storeOption;
        }
        api_1.default.createProductOptionItem({
            name: value,
            productOptionId: productOption.id
        })
            .then(function (response) {
            productOptionsStore.editDataItem(__assign(__assign({}, targetOption), { productOptionItems: __spreadArrays(targetOption.productOptionItems, [
                    response.data
                ]) }));
            putOptionItem(response.data);
        })
            .catch(api_1.catchHandler);
    };
    var removeItemHandler = function (productOptionItemValue) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Remove Option?",
            description: 'Are you sure you want to remove this option?'
        })
            .then(function () {
            api_1.default.deleteProductOptionItemValue(productOptionItemValue)
                .then(function (response) {
                productsStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: SAVE_MESSAGE
                });
            });
        });
    };
    var changeItemHandler = function (productOptionItemValue) {
        api_1.default.editProductOptionItemValue(productOptionItemValue)
            .then(function (response) {
            productsStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: SAVE_MESSAGE
            });
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'edit-product__page edit-product-options' },
        react_1.default.createElement("span", { className: 'title' }, "Product Options"),
        react_1.default.createElement("div", { className: 'help flex flex-row' },
            react_1.default.createElement("img", { src: help_icon_svg_1.default, alt: 'Help' }),
            react_1.default.createElement("p", null,
                "These options can be selected by customers to customise products, for example: clothes sizes or available colours.",
                react_1.default.createElement("br", null),
                " If an option does not have its own price and stock, it will default to the basic product's values.",
                react_1.default.createElement("br", null),
                " Only one option group may control price and stock.")),
        product.productOptions &&
            product.productOptions.map(function (productOption) { return (react_1.default.createElement(EditProductOptionsGroup_1.default, { key: productOption.id, productOption: productOption, otherGroups: product.productOptions, storeOptionItems: getStoreOptions(productOption.id), onRemoveOption: removeOptionHandler, onAddItem: putOptionItem, onSubmitItem: function (item) { return submitItemHandler(productOption, item); }, onRemoveItem: removeItemHandler, onChangeItem: changeItemHandler })); }),
        !open &&
            react_1.default.createElement(AddButton_1.default, { label: 'Add product option', onClick: toggleOpen }),
        open &&
            react_1.default.createElement("div", { className: 'edit-product__add-form form' },
                react_1.default.createElement("div", { className: 'edit-product__add-form__top flex flex-row flex-space-between' },
                    react_1.default.createElement("span", { className: 'title' }, "Add a product option"),
                    react_1.default.createElement("button", { type: 'button', title: 'Close', "aria-label": 'close', className: 'edit-product-specs__form__close flex flex-column flex-center', onClick: toggleOpen },
                        react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Close' }))),
                react_1.default.createElement(SelectWithNewEntry_1.default, { value: null, label: 'Product Option', data: getOptions(), onChange: putOption, onSubmit: submitOptionHandler }))));
});
exports.default = EditProductOptions;
